<div class="track-my-location-container support-container">
  <div class="track-my-location">

    <div class="header col-12 md:col-12 lg:col-12 sm:col-12">
      <div class="col-6 md:col-12 lg:col-6 sm:col-12">
        <a>
          <img width="200" height="52px" src="/assets/images/temp/nbx_header_logo.svg" style="background-color: #666666; padding: 10px;">
        </a>
      </div>
    </div>
    <div class="  col-12 md:col-12 lg:col-12">
      <div class="seperator"></div>
    </div>
    @if (supportData) {
      <div class="col-12" style="
      margin-right: 4em;
      padding: 23px;
      font-size: 10px;">
      <div class="  col-12 md:col-12 lg:col-12">
        <h2>Want to get in touch? We would love to hear from you.
          You can reach out to us on :</h2>
      </div>
        @if (supportData && supportData.organisationName) {
          <div class="  col-12 md:col-12 lg:col-12">
            <h2>Organization Name : {{supportData.organisationName}}</h2>
          </div>
        }
        @if (supportData && supportData.website) {
          <div class="  col-12 md:col-12 lg:col-12">
            <h2>Website : {{supportData.website}}</h2>
          </div>
        }
        @if (supportData['email']) {
          <div class="  col-12 md:col-12 lg:col-12">
            <h3 class="cursor-pointer" (click)="sendEmail(supportData['email'])">Email : {{supportData['email']}}</h3>
          </div>
        }

        @if (supportData['supportNumber']) {
          <div class="  col-12 md:col-12 lg:col-12">
            <h3 class="cursor-pointer" (click)="callSupportNumber(supportData['supportNumberCode'], supportData['supportNumber'])">Number : {{supportData['supportNumberCode']}} {{supportData['supportNumber']}}</h3>
          </div>
        }
        <!-- <div *ngIf = "supportData.contacts.length > 0">
          <div *ngFor = "let eachnumber of supportData.contacts ; index as i" class="  col-12 md:col-12 lg:col-12">
            <h3>Support Number {{(i+1)}} : <a [href]="'tel:'+eachnumber">{{eachnumber}}</a></h3>
          </div>
        </div> -->
        @if (supportData && supportData.addressLine1) {
          <div class="  col-12 md:col-12 lg:col-12">
            <h2>Address : {{supportData.addressLine1}} ,{{supportData.addressLine2}}</h2>
          </div>
        }
       
      </div>
    }
  </div>
</div>
